import { render, staticRenderFns } from "./GroupPriceChart.vue?vue&type=template&id=321f8cdd&scoped=true&"
import script from "./GroupPriceChart.vue?vue&type=script&lang=js&"
export * from "./GroupPriceChart.vue?vue&type=script&lang=js&"
import style0 from "./GroupPriceChart.vue?vue&type=style&index=0&id=321f8cdd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321f8cdd",
  null
  
)

export default component.exports